export default __webpack_public_path__ + "static/media/drowsy.42be9b89.png";